export default __webpack_public_path__ + "media/plano de saude.jpg";